import AsyncSelect, {
  Option,
  type AsyncSelectBaseProps,
} from "@/components/AsyncSelect";
import { useTranslation } from "react-i18next";
import { forwardRef } from "react";
import { EntityListLink } from "@/components/EntityListLink";
import { Module, PATH_DICTS_UPDATES_DEPARTMENTS } from "@/constants";
import { fetchDepartmentList } from "@/services/department";
import appConfiguration from "@/components/cfg/AppCfg";

interface DepartmentSelectProps extends AsyncSelectBaseProps {
  className?: string;
  inDialog?: boolean;
  defaultItem?: Partial<Option>;
}

export default forwardRef<HTMLButtonElement, DepartmentSelectProps>(
  function DepartmentSelect({ value, inDialog, defaultItem, ...props }, ref) {
    const { t } = useTranslation();

    return (
      <span className="flex items-center gap-1">
        <AsyncSelect
          queryKey={[Module.UpdatesDepartments]}
          queryFn={() =>
            fetchDepartmentList({
              limit: appConfiguration.selectComponentsPaginationLimit,
            })
          }
          placeholder={t("departmentSelect.placeholder")}
          loadingLabel={t("departmentSelect.loadingDepartments")}
          {...props}
          value={value ? value.toString() : undefined}
          ref={ref}
          enableFilter={false}
          inDialog={inDialog}
          defaultItem={defaultItem}
        />
        <EntityListLink
          path={PATH_DICTS_UPDATES_DEPARTMENTS}
          label={t("departmentSelect.link")}
        />
      </span>
    );
  },
);
